/**
 * About Page Component
 * 
 * Static about page providing information about the ContactGenie application
 * Displays public information about the platform
 * 
 * Features:
 * - Simple informational layout
 * - Static content display
 * - Public page (no authentication required)
 * 
 * @component
 * @returns {JSX.Element} About page with product information
 * 
 * @example
 * // Usage in router
 * <Route path="/about" element={<About />} />
 */

import React from "react";

/**
 * About Component
 * Renders the application about page
 * 
 * @function
 * @returns {JSX.Element} Page with about information
 */
export const About = () => {
     return (
          <div className="page">
               {/* Page heading */}
               <h2>About page</h2>
               {/* About page description text */}
               <p>This is the text for the about page</p>
          </div>
     )
}